import { io } from "socket.io-client";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
let socket = null;

// Shared Socket.IO client for real-time order updates on kitchen/staff screens.
export function getSocket() {
  if (!socket) {
    socket = io(BACKEND, {
      path: "/api/socket.io",
      transports: ["polling", "websocket"],
      withCredentials: false,
      reconnection: true,
    });
  }
  return socket;
}
